export default () => (
    {
        imageUrl: '',
        loaded: false,
        shown: false,
        shownTransitionEnd: false,
        opacity: 0,
        opacityInterval: null,
        opacityDuration: 150,
        opacitySteps: 15,
        sliderElAncestor: null,
        useOpacity: false,

        init() {
            this.imageUrl   = this.$el.dataset.imageUrl;
            this.useOpacity = !!parseInt(this.$el.dataset.useOpacity);

            this.$watch('shown', () => {
                if (!this.shown) return;
                setTimeout(() => {
                    this.shownTransitionEnd = true;
                }, this.opacityDuration);
            });
        },

        loadImage() {
            if (this.loaded) return;

            this.sliderElAncestor = this.$root.closest('.swiper');

            // Rely on x-on:load="onImageLoad" on the <img> child to call onImageLoaded().
            // Preloading via new Image() always fetched data-image-url (the full original),
            // bypassing srcset entirely and causing a redundant multi-MB download.
            const imgChild = this.$el.querySelector('img');
            if (imgChild?.complete) {
                this.onImageLoaded();
            }
        },

        onImageLoaded() {

            this.loaded = true;

            if (!this.useOpacity) {
                this.shown = true;
                return;
            }

            let opacityIntervalTimeout = 100;

            this.opacityInterval = setInterval(() => {
                if (this.sliderElAncestor !== null) {
                    if (this.sliderElAncestor.classList.contains('swiper-touching')) return;
                    if (this.sliderElAncestor.classList.contains('swiper-transition')) return;
                }

                if (this.opacity >= 1) {
                    clearInterval(this.opacityInterval);
                    this.shown = true;
                    return;
                }

                setTimeout(() => {
                    this.opacity = 1;
                }, 150);

            }, opacityIntervalTimeout);
        },

        isImageCached(src) {
            const img = new Image();
            img.src   = src;
            return img.complete;
        },

        onImageLoad() {
            this.onImageLoaded();
        }

    });